const TotalSVG = ({ totalPprogress }) => {
    const totalCircles = 15 * 4; // Всього 60 кіл (15 колонок по 4 ряди)
    const filledCircles = Math.round((totalPprogress / 100) * totalCircles); // Кількість залитих кіл
  
    return (
      <svg
        id="okr-circles"
        xmlns="http://www.w3.org/2000/svg"
        width="995"
        height="229"
        viewBox="0 0 995 229"
        fill="none"
      >
        {[...Array(15)].map((_, col) =>
          [...Array(4)].map((_, row) => {
            const index = col * 4 + row; // Послідовний індекс кола
            return (
              <circle
                key={`${col}-${row}`}
                cx={col * 68 + 21.5}
                cy={row * 62 + 21.5}
                r="21.5"
                fill="#664499"
                fillOpacity={index < filledCircles ? "1" : "0.3"} // Заповнені або напівпрозорі
              />
            );
          })
        )}
      </svg>
    );
  };
  
  export default TotalSVG;
  